var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMicrophoneOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_742_194)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292893 0.292893C0.683417 -0.097631 1.31658 -0.097631 1.70711 0.292893L23.7071 22.2929C24.0976 22.6834 24.0976 23.3166 23.7071 23.7071C23.3166 24.0976 22.6834 24.0976 22.2929 23.7071L15.6576 17.0718C14.8733 17.5196 13.9776 17.8182 13 17.9392V21H16C16.5523 21 17 21.4477 17 22C17 22.5523 16.5523 23 16 23H12H8C7.44772 23 7 22.5523 7 22C7 21.4477 7.44772 21 8 21H11V17.9392C7.83516 17.5476 5.52924 15.2958 5.07947 12.1411C5.00152 11.5944 5.38156 11.088 5.92832 11.01C6.47507 10.9321 6.9815 11.3121 7.05945 11.8589C7.41051 14.3212 9.29223 16 11.9998 16C12.8009 16 13.5298 15.853 14.168 15.5823L13.3517 14.7659C12.9294 14.9174 12.4744 15 12 15C9.79086 15 8 13.2091 8 11V9.41421L0.292893 1.70711C-0.097631 1.31658 -0.097631 0.683417 0.292893 0.292893ZM11.5303 12.9445L10.0555 11.4697C10.2305 12.197 10.803 12.7695 11.5303 12.9445ZM14 9.79257V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.79257L8.14314 3.93571C8.60914 2.2432 10.1594 1 12 1C14.2091 1 16 2.79086 16 5V11C16 11.2482 15.9774 11.4911 15.9341 11.7267L14 9.79257ZM18.9201 12.1411C18.8183 12.8552 18.6214 13.5231 18.341 14.1335L16.7876 12.5802C16.8536 12.3484 16.9047 12.1076 16.9401 11.8589C17.0181 11.3121 17.5245 10.9321 18.0713 11.01C18.618 11.088 18.9981 11.5944 18.9201 12.1411Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_742_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMicrophoneOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconMicrophoneOff.fc70c51560ffab78dd47d4e2dd135186.svg";